<template>
  <div class="footer"><p>Copyright © {{ new Date().getFullYear() }} Project Passive, LLC</p></div>
</template>

<script>
export default {
  
}
</script>